import React from "react";
const SvgLoginResearchNotifications = props => (
  <svg fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M14.946 5.75a9.196 9.196 0 100 18.392 9.2 9.2 0 008.621-5.987.75.75 0 111.406.523c-1.514 4.066-5.431 6.964-10.027 6.964-5.907 0-10.696-4.789-10.696-10.696S9.039 4.25 14.946 4.25a.75.75 0 010 1.5z"
      clipRule="evenodd"
    />
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M21.47 21.47a.75.75 0 011.06 0l5.595 5.594a.75.75 0 01-1.061 1.06L21.47 22.53a.75.75 0 010-1.06z"
      clipRule="evenodd"
    />
    <path
      fill="#E4002B"
      fillRule="evenodd"
      d="M23.002.625c-.87 0-1.645.469-2.028 1.165a5.218 5.218 0 00-1.604.98c-.93.834-1.445 1.945-1.445 3.127v.132c0 2.138-.46 3.974-1.38 5.98-.171.372-.137.804.093 1.143.223.33.596.598 1.01.598h10.708c.402 0 .79-.251 1.012-.603.231-.344.248-.77.093-1.131a.313.313 0 00-.039-.066c-.902-1.974-1.352-3.804-1.352-5.92 0-1.877-1.268-3.51-3.038-4.229-.382-.705-1.159-1.176-2.03-1.176z"
      clipRule="evenodd"
    />
    <path
      fill="#F095A6"
      fillRule="evenodd"
      d="M25.094 14.375H20.91c.354.754 1.17 1.25 2.091 1.25.922 0 1.74-.493 2.093-1.25z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLoginResearchNotifications;
